import Auth from '../lib/auth'

const AuthPlugin = {
  install(Vue) {
    if (!Vue.axios) throw new Error('Axios must be installed before Auth')
    const _auth = new Auth(Vue.axios)
    Object.defineProperties(Vue.prototype, {
      $auth: { get() { return _auth } }
    })
  }
}

export default AuthPlugin
